import React from 'react';
import Reflux from 'reflux';
import Modal from 'react-modal';

import i18 from '../../../i18';
import Field from '../../common/Field';
import Validator from '../../common/Validator';
import {supplierRuleApi} from '../../../api';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root');

class RuleUpdateModal extends Reflux.Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: this.createFields(props.rule),
            saving: false,
        };
    }

    createFields = (rule) => {
        return {
            supplier_name: {
                value: rule.supplier_name || '',
                error: '',
                role: {required: false},
            },
            item_name: {
                value: rule.item_name || '',
                error: '',
                role: {required: false},
            },
            position_number_country: {
                value: rule.position_number_country || '',
                error: '',
                role: {required: false},
            },
            order_number_stat: {
                value: rule.order_number_stat || '',
                error: '',
                role: {required: false},
            },
            main_bookkeeping_number: {
                value: rule.main_bookkeeping_number || '',
                error: '',
                role: {required: true},
            },
            vat: {
                value: rule.vat !== null && typeof rule.vat !== 'undefined'
                    ? rule.vat
                    : '',
                error: '',
                role: {required: true},
            },
            vat_degree: {
                value: rule.vat_degree || '',
                error: '',
                role: {required: true},
            },
            vat_collector_id: {
                value: rule.vat_collector_id || '',
                error: '',
                role: {required: true},
            },
            type: {
                value: rule.type || 'temporarily',
                error: '',
                role: {required: true},
            },
            position: {
                value: rule.position,
                error: '',
                role: {required: true},
            },
        };
    };

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    setValue = (name, value, error = '') => {
        this.setState((previousState) => ({
            fields: {
                ...previousState.fields,
                [name]: {
                    ...previousState.fields[name],
                    value,
                    error,
                },
            },
        }));
    };

    onElementChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setValue(
            name,
            value,
            '',
        );
    };

    validate = () => {
        const validatorResponse = Validator.validate(
            this.state.fields,
        );

        if (validatorResponse.error) {
            this.setState({
                fields: validatorResponse.fields,
            });

            return false;
        }

        return true;
    };

    buildPayload = () => {
        const {fields} = this.state;

        return {
            supplier_name: this.getNullableStringValue(fields.supplier_name.value),
            item_name: this.getNullableStringValue(fields.item_name.value),
            position_number_country: this.getNullableStringValue(fields.position_number_country.value),
            order_number_stat: this.getNullableStringValue(fields.order_number_stat.value),
            main_bookkeeping_number: String(fields.main_bookkeeping_number.value).trim(),
            vat: fields.vat.value,
            vat_degree: String(fields.vat_degree.value).trim(),
            type: fields.type.value,
            vat_collector_id: fields.vat_collector_id.value,
            position: fields.position.value,
        };
    };

    updateRule = async () => {
        if (this.state.saving) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        this.setState({
            saving: true,
        });

        try {
            const responseData = await supplierRuleApi.update(
                this.getCompanyId(),
                this.props.rule.id,
                this.buildPayload(),
            );

            this.props.updateRules(
                responseData.supplierRules,
            );

            this.props.notifySuccess(
                'A szabály szerkesztése sikeres.',
            );

        this.props.editRule(null);
        } catch (error) {
        this.setState({
            saving: false,
        });

            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'A szabály mentése sikertelen.',
                ),
            );
        }
    };

    closeModal = () => {
        if (this.state.saving) {
            return;
        }

        this.props.editRule(null);
    };

    getNullableStringValue = (value) => {
        const normalizedValue = String(value).trim();

        return normalizedValue === ''
            ? null
            : normalizedValue;
    };

    renderTextField = (
        name,
        label,
        classLabel = 'control-label margin-bottom-2 margin-top-10',
    ) => {
        return (
            <Field
                type="text"
                id={name}
                name={name}
                label={label}
                classLabel={classLabel}
                classInput="form-control"
                setValue={this.setValue}
                state={this.state}
                style={{
                    width: '100%',
                    minWidth: '350px',
                }}
            />
        );
    };

    renderSelect = (
        name,
        label,
        options,
    ) => {
        const {
            fields,
            saving,
        } = this.state;

        return (
            <React.Fragment>
                <label
                    htmlFor={name}
                    className="margin-top-10 margin-bottom-2 control-label"
                >
                    {label}
                </label>

                <select
                    value={fields[name].value}
                    name={name}
                    id={name}
                    onChange={this.onElementChange}
                    className="minimal-100 form-control"
                    disabled={saving}
                >
                    {options}
                </select>

                {fields[name].error ? (
                    <div className="text-danger">
                        {fields[name].error}
                    </div>
                ) : null}
            </React.Fragment>
        );
    };

    renderVatCollectorOptions = () => {
        return (
            <React.Fragment>
                <option value="">
                    Kérjük válasszon
                </option>

                {this.props.vatCollectorCodes.map(
                    (vatCollectorCode) => (
                        <option
                            value={vatCollectorCode.id}
                            key={vatCollectorCode.id}
                        >
                            {vatCollectorCode.code}
                            &nbsp;({vatCollectorCode.title})
                        </option>
                    ),
                )}
            </React.Fragment>
        );
    };

    renderRuleTypeOptions = () => {
        return (
            <React.Fragment>
                <option value="temporarily">
                    {i18.COMMON._temporarirlyRule}
                </option>

                <option value="final">
                    {i18.COMMON._finalRule}
                </option>
            </React.Fragment>
        );
    };

    render() {
        const {rule} = this.props;

        if (!rule) {
            return null;
        }

        const {
            saving,
        } = this.state;

        return (
            <Modal
                isOpen
                onRequestClose={this.closeModal}
                shouldCloseOnOverlayClick={!saving}
                shouldCloseOnEsc={!saving}
                style={customStyles}
                contentLabel={i18.COMMON._editRuleText}
                shouldReturnFocusAfterClose={false}
            >
                <h4>
                    #{rule.id} {i18.COMMON._editRuleText}
                </h4>

                <div className="modal-body">
                    {this.renderTextField(
                        'supplier_name',
                        i18.SUPPLIER._supplierName,
                    )}

                    {this.renderTextField(
                        'item_name',
                        i18.SUPPLIER._typeOfTraffic,
                    )}

                    {this.renderTextField(
                        'position_number_country',
                        i18.SUPPLIER._positionNumberCountry,
                    )}

                    {this.renderTextField(
                        'order_number_stat',
                        i18.SUPPLIER._orderNumberStat,
                    )}

                    {this.renderTextField(
                        'vat',
                        i18.SUPPLIER._VAT,
                    )}

                    {this.renderTextField(
                        'main_bookkeeping_number',
                        i18.SUPPLIER._mainBookNumber,
                    )}

                    {this.renderTextField(
                        'vat_degree',
                        i18.SUPPLIER._vatDegreeNumber,
                    )}

                    {this.renderSelect(
                        'vat_collector_id',
                        i18.SUPPLIER._collectorCode,
                        this.renderVatCollectorOptions(),
                    )}

                    {this.renderSelect(
                        'type',
                        i18.COMMON._typeOfRule,
                        this.renderRuleTypeOptions(),
                    )}

                    {this.renderTextField(
                        'position',
                        i18.COMMON._position,
                    )}
                </div>

                <div className="modal-footer text-center">
                    <button
                        type="button"
                        onClick={this.updateRule}
                        className="btn btn-success btn-sm mr-2"
                        disabled={saving}
                    >
                        {saving
                            ? 'Mentés...'
                            : i18.COMMON._save
                        }
                    </button>

                    <button
                        type="button"
                        onClick={this.closeModal}
                        className="btn btn-danger btn-sm"
                        disabled={saving}
                    >
                        {i18.COMMON._close}
                    </button>
                </div>
            </Modal>
        );
    }
}

export default RuleUpdateModal;


// WEBPACK FOOTER //
// ./src/components/supplier/rules/RuleUpdateModal.js